import { render, staticRenderFns } from "./FlagFrance.vue?vue&type=template&id=0cfdf936&"
import script from "./FlagFrance.vue?vue&type=script&lang=js&"
export * from "./FlagFrance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports